import React from "react";
var __jsx = React.createElement;
import { useTranslations } from "next-intl";
import Dialog from "@mui/material/Dialog";
import { useEffect, useRef } from "react";
import Paper from "@mui/material/Paper";
import { XMarkIcon } from "@heroicons/react/24/outline";
import LoadingAnimation from "@modules/shared/animations/loading";
import APP_CONFIGURATION from "@lib/app.config";
import { cn } from "@lib/cn";
import { useCustomer } from "@lib/context/shared/customer-context";
import { MuscleButton } from "../../buttons";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { DEFAULT_APP } from "@lib/constants";
const IframeLogin = _ref => {
  var _process$env$NEXT_PUB, _localStorage$getItem;
  let {
    openState,
    setOnOpenState,
    src,
    width = '300px',
    validate,
    loading,
    isExpiredSession,
    closable
  } = _ref;
  const t = useTranslations("Shared");
  const iframeRef = useRef(null);
  const {
    isSessionProviderActive,
    customerIsLogged,
    logoutFromFrontend,
    handleSearchRedirection
  } = useCustomer();
  const router = useMuscleRouter();
  const {
    isHome
  } = useMuscleRouter();
  const defaultApp = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_DEFAULT_APP) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : DEFAULT_APP;
  const actualApp = (_localStorage$getItem = localStorage.getItem("current-app")) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : defaultApp;
  useEffect(() => {
    const receiveMessage = event => {
      var _event$data, _userIdRaw$split;
      if (!(event !== null && event !== void 0 && (_event$data = event.data) !== null && _event$data !== void 0 && _event$data.code)) return;
      const result = event.data.code;
      const [code, userIdRaw] = result.split('&', 2);
      const userId = (_userIdRaw$split = userIdRaw.split('=')) === null || _userIdRaw$split === void 0 ? void 0 : _userIdRaw$split[1];
      validate(code, userId, !isSessionProviderActive);
    };
    window.addEventListener("message", receiveMessage);
    return () => {
      window.removeEventListener("message", receiveMessage);
    };
  }, []);
  useEffect(() => {
    if (isExpiredSession) {
      logoutFromFrontend();
    }
  }, [isExpiredSession]);
  return __jsx("div", {
    className: "global-max-page-width"
  }, __jsx(Dialog, {
    open: openState,
    onClose: setOnOpenState,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    className: "max-w-full",
    PaperProps: {
      component: Paper,
      className: cn('!max-w-full !max-h-full h-full !m-0 md:!h-fit rounded-[10px] md:w-[450px]  md:!h-[764px]'),
      style: {
        borderRadius: '10px'
      }
    },
    maxWidth: false,
    style: {
      zIndex: 1000000
    }
  }, !loading && !isExpiredSession && closable && __jsx("div", {
    className: "absolute top-2 right-2  p-4"
  }, __jsx(XMarkIcon, {
    fontSize: 16,
    className: "h-6 w-6 cursor-pointer",
    "aria-hidden": "true",
    onClick: () => {
      setOnOpenState(false);
    }
  })), __jsx("div", {
    className: cn("flex flex-col items-center justify-center w-full max-w-[500px] h-full ", {
      'mt-[46px] gap-2': !isExpiredSession
    })
  }, isExpiredSession ? __jsx("div", {
    className: "max-w-[500px] flex flex-col text-center items-center mt-8  px-4"
  }, __jsx("h4", {
    className: "tx-h5-semiBold text-center max-w-[350px] text-primary_text mb-1"
  }, t('Auth.PROVIDER_AUTH.SESSION_EXPIRED')), !isHome() && __jsx("p", {
    className: "tx-pmd-regular text-neutral-500"
  }, t('Auth.PROVIDER_AUTH.SESSION_EXPIRED_MESSAGE', {
    providerName: APP_CONFIGURATION.config.pointsProviderName
  }))) : __jsx("h5", {
    className: "tx-plg-semiBold md:tx-h5-semiBold text-center max-w-[500px]  px-4 text-primary_text"
  }, t('Auth.PROVIDER_AUTH.LOGIN_OR_REGISTER_TO_CONTINUE')), __jsx("iframe", {
    ref: iframeRef,
    src: src,
    width: width,
    frameBorder: "0",
    scrolling: "true",
    className: loading ? "hidden" : "block h-full"
  }), !isHome() && isExpiredSession ? __jsx(MuscleButton, {
    variant: "link",
    onClick: () => {
      setOnOpenState(false);
      handleSearchRedirection();
      localStorage.setItem('expiration-state', 'closed');
    },
    className: "text-nowrap mx-auto tx-pmd-bold -translate-y-5 ".concat(loading ? "hidden" : "block")
  }, t("Auth.BACK_TO_SEARCH_GUEST_USER")) : isExpiredSession && __jsx(MuscleButton, {
    variant: "link",
    onClick: () => {
      localStorage.setItem('expiration-state', 'closed');
      setOnOpenState(false);
    },
    className: "text-nowrap mx-auto tx-pmd-bold -translate-y-5 ".concat(loading ? "hidden" : "block")
  }, t("Auth.EXPIRED_SESSION_CONTINUE_WITHOUT_LOGGIN_BUTTON"))), loading && __jsx("div", {
    className: "flex h-full items-center justify-center"
  }, __jsx(LoadingAnimation, {
    height: 80
  }))));
};
export default IframeLogin;